import { render, staticRenderFns } from "./LazyEntitySelectView.vue?vue&type=template&id=508a974b&scoped=true&"
import script from "./LazyEntitySelectView.vue?vue&type=script&lang=js&"
export * from "./LazyEntitySelectView.vue?vue&type=script&lang=js&"
import style0 from "./LazyEntitySelectView.vue?vue&type=style&index=0&id=508a974b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a974b",
  null
  
)

export default component.exports